/**
 * vue-gtag-next が `<head>` に注入する GA の gtag.js が広告/トラッカーブロッカー等で
 * ロード失敗すると、`script.onerror = reject` により生の DOM `error` Event が
 * promise rejection の値になり、未捕捉のまま Sentry に届く (SREST-FRONTEND-XH)。
 * アプリのバグではないため報告を抑制する。
 *
 * 発生源を GA (`event.target.src` が googletagmanager.com) に限定する。
 * `type === 'error'` の Event を一律で落とすと、他の第三者スクリプト失敗やアプリ側の
 * 同種コードまで不可視になるため (レビュー指摘)。
 */
export const isGtagLoadErrorEvent = (exception: unknown): boolean => {
  if (!(exception instanceof Event) || exception.type !== 'error') return false;
  const src = (exception.target as { src?: unknown } | null)?.src;
  return typeof src === 'string' && src.includes('googletagmanager.com');
};
